import {Inject, Injectable, Optional} from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import {environment, CustomEnvironment, setApiOverrides} from '../../environments/environment';
import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {HttpErrorHandlerService, HandleError} from './http-error-handling.service';
import { AUTH_SERVICE_TOKEN } from './tokens';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable()
export class HistoryService {
  private handleError: HandleError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService,
    @Inject(CustomEnvironment) customEnvironment: any,
    @Optional() @Inject(AUTH_SERVICE_TOKEN) private authService?: any,
  ) {
    setApiOverrides(customEnvironment);
    this.handleError = httpErrorHandler.createHandleError('HistoryService');
  }

  getOptions() {
    if (this.authService) {
      httpOptions.headers = httpOptions.headers.set('Authorization', this.authService.authorizationHeader());
    } else {
      console.warn('AuthService is not provided!');
    }
    return httpOptions;
  }

  queryString(data) { 
    if(!data) return;

    return Object.keys(data).filter((k) => !!data[k]).map((k) => k + '=' + encodeURIComponent(data[k])).join('&');
  };

  getHistoryNotes(type: string, appId: number, s, sd, p, ps, cat): Observable<any> {
    return this.http.get(`${environment.api.history}/${type}/${appId}/notes?s=${s}&sd=${sd}&p=${p}&ps=${ps}&cat=${cat}`, httpOptions);
  }

  getHistoryNotesCount(type: string, appId: number, cat: string): Observable<any> {
    return this.http.get(`${environment.api.history}/${type}/${appId}/count?cat=${cat}`, httpOptions);
  }

  searchHistoryNotes(type: string, appId: number, str: string, s, sd, p, ps, cat): Observable<any> {
    return this.http.get(`${environment.api.history}/${type}/${appId}/notes?str=${str}&s=${s}&sd=${sd}&p=${p}&ps=${ps}&cat=${cat}`, httpOptions);
  }

  createHistoryNote(type: string, appId: number, data: any) {
    return this.http.post(`${environment.api.history}/${type}/${appId}`, data, httpOptions)
      .pipe(
        catchError(this.handleError('createHistoryNote', []))
      );
  }

  getHistory(identType: string, id: any, p: number, ps: number, opts?:any): Promise<any> {
    let url = `${environment.api.history}/${identType}/${id}?p=${p}&ps=${ps}`;
    if(opts){
      url += `&${this.queryString(opts)}`;
    }
    return this.http.get(url, this.getOptions()).toPromise();
  }

  getAuditHistory(identType: string, id: any, p: number, ps: number, opts: any = {}, model: string = 'data') {
    let params = `p=${p}&ps=${ps}&`;
    const qsParams = opts || {};
    if (model == 'data') {
      qsParams.cat = 'audit';
    }
    if (qsParams) {
      params += Object.keys(qsParams).map((key) => `${key}=${opts[key]}`).join('&');
    }
    if (model !== 'audit' && model !== 'data') {
      throw new Error('getAuditHistory must be called with either "data-note" or "audit" as the model types');
    }

    return this.http.get(`${environment.api.history}/${identType}/${id}/${model}?${params}`, this.getOptions()).toPromise();
  }
}
